export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const SET_NOTIFICATION_STATE = "SET_NOTIFICATION_STATE"
export const RESET_CURRENT_NOTIFICATION = "RESET_CURRENT_NOTIFICATION"
export const SET_FILTER_TOTAL = 'SET_FILTER_TOTAL'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_RESULT_COUNT = 'SET_RESULT_COUNT'
export const SET_SEARCH_QUERY = 'setSearchQuery' // lower case for backwards compat
export const SET_FILTER_CATEGORY = 'setFilterCategories' // lower case for backwards compat